<div>
  <label>{{ message }}</label>
</div>
